var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-box"},[_c('web-header'),_vm._v(" "),_c('web-slide',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('web-products',{attrs:{"products":_vm.products}}),_vm._v(" "),_c('web-parallax'),_vm._v(" "),_c('web-footer'),_vm._v(" "),_c('web-arrow-up')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c4caef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/categories/suplementos.vue
// module id = y/vF
// module chunks = 0